export enum IrbCreatePortfolioEvents {
    SHOW_CREATE_PORTFOLIO = "IRBCREATEPOPRTFOLIOEVENTS.SHOW_CREATE_PORTFOLIO",
    SHOW_PORTFOLIO_ACCOUNT_ASSIGNMENT = "IRBCREATEPOPRTFOLIOEVENTS.SHOW_PORTFOLIO_ACCOUNT_ASSIGNMENT",
    SHOW_PORTFOLIO_IMPORT_HOLDINGS = "IRBCREATEPOPRTFOLIOEVENTS.SHOW_PORTFOLIO_IMPORT_HOLDINGS",
    SHOW_PORTFOLIO_CREATED = "IRBCREATEPOPRTFOLIOEVENTS.SHOW_PORTFOLIO_CREATED"
}